const WizardReducer = (state = {currentStep: 1, progress: 1}, action) => {
    switch (action.type) {
        case 'wizard/UPDATE_FORM':
            return {...state, ...action.payload};
        case 'wizard/RESET_FORM':
            return {
                // TODO Do something more intelligent here to handle logins, etc...
                currentStep: 1,
                progress: 1
            };
        default:
            return state;
    }
};

export default WizardReducer;